import useSWR from "@/hooks/useSWR";
import { ActivationStatusType } from "@/types/ActivationStatusTypes";
import { isAxiosError } from "axios";

export default function useAccountActivation(sessionToken: string | undefined) {
  const {
    data: activationStatus,
    mutate: mutateActivationStatus,
    error: activationError,
  } = useSWR<ActivationStatusType>(
    {
      url: `/activation/`,
      enabled: !!sessionToken,
    },
    {
      onErrorRetry: (error) => {
        if (isAxiosError(error) && error.response?.status === 401) return;
      },
      revalidateOnFocus: false,
    }
  );

  return { activationStatus, mutateActivationStatus, activationError };
}
